import React, { useEffect } from 'react';
import { useRouteMatch, Redirect } from 'react-router-dom';
import { GlobalState } from '../../../../redux/root-reducer';
import { Dispatch } from 'redux';
import QuizActionAPI, {
    IDeleteQuizPayload,
} from '../../../../redux/quiz/quiz.actions';
import { fetchApi } from '../../../../redux/fetch/fetch.actions';
import { connect } from 'react-redux';
import Loading from '../../../../components/loading/loading.component';

interface IProps {
    isFetching?: boolean;
    errors?: string | null;
    clearQuizzes: () => void;
    deleteQuiz: (id: number) => void;
}

function DeletQuizContainer({
    isFetching,
    errors,
    clearQuizzes,
    deleteQuiz,
}: IProps) {
    const match = useRouteMatch<{ id: string }>();
    const id = parseInt(match.params.id);

    useEffect(() => {
        if (isFetching || errors) return;
        deleteQuiz(id);
        return () => {
            clearQuizzes();
        };
    }, [isFetching, errors, deleteQuiz, id, clearQuizzes]);

    return (
        <>
            {isFetching ? (
                <Loading className="fixed" />
            ) : (
                <Redirect to="/quiz/view" />
            )}
        </>
    );
}

const mapStateToProps = ({
    fetchController: { isFetching, errors },
}: GlobalState) => ({
    isFetching: isFetching.DELETE_QUIZ,
    errors: errors.DELETE_QUIZ,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    clearQuizzes: () => dispatch(QuizActionAPI.clearQuizzes()),
    deleteQuiz: (id: IDeleteQuizPayload['data']['id']) =>
        dispatch(fetchApi({ name: 'DELETE_QUIZ', data: { id } })),
});

const DeleteQuizPage = connect(
    mapStateToProps,
    mapDispatchToProps
)(DeletQuizContainer);

export default DeleteQuizPage;
